/* @flow */

export const SWITCH_EVENTS: string = 'SWITCH_EVENTS';
export const DISMISS_FLASH_MESSAGE: string = 'DISMISS_FLASH_MESSAGE';

export const UPCOMING_EVENTS: string = 'UPCOMING_EVENTS';
export const PAST_EVENTS: string = 'PAST_EVENTS';

export const showUpcomingEvents = () => {
  return {
    type: SWITCH_EVENTS,
    payload: UPCOMING_EVENTS
  };
};

export const showPastEvents = () => {
  return {
    type: SWITCH_EVENTS,
    payload: PAST_EVENTS
  };
};

export const dismissFlashMessage = () => {
  return {
    type: DISMISS_FLASH_MESSAGE
  };
};



// WEBPACK FOOTER //
// ./src/modules/profile/actions.js